<template>
  <div>
    <div class="results-header">
      <div class="container container--small">
        <span class="size--l">fertig!</span>
        <h2 class="size--xxl">Unsere Lösungen für Ihr Dämmprojekt:</h2>
      </div>
    </div>

    <div class="container">
      <carousel class="slider" :centerMode="true" :perPage="1" :perPageCustom="[[768, 2]]">
        <slide class="slider__item" v-for="(result, index) in results" v-bind:key="index">
          <ResultTeaser v-bind="$store.state.products[result]" />
        </slide>
      </carousel>

      <button
        class="restart-finder"
        type="button"
        @click="() => $store.dispatch('restartFinder')"
      >
        <span>Von vorne beginnen</span>
        <Icon id="triangle" />
      </button>
    </div>
  </div>
</template>

<script>
import ResultTeaser from '@/components/finder/ResultTeaser.vue';
import Icon from '@/components/Icon.vue';

export default {
  components: {
    ResultTeaser,
    Icon,
  },
  props: {
    results: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.results-header {
  text-align: center;
}

.restart-finder {
  background: transparent;
  margin: 20px auto 0;
  padding: 10px;
  display: block;
  cursor: pointer;
  color: $color-secondary-light;
  border: 0;

  span {
    margin-right: 8px;
    display: inline-block;
    border-bottom: 1px solid $color-secondary-light;
  }

  .icon {
    width: 12px;
    height: 12px;
    fill: $color-primary;
    color: $color-primary;
    transform: translateY(2px);
  }
}

.slider {
  margin: 0 -#{$container-padding / 2};

  &__item {
    width: 100%;
    padding: 0 $container-padding / 2;
  }
}
</style>
